import React from 'react';
import { Globe, Calendar, Users, Smartphone } from 'lucide-react';
import { whyYouSeeingThis, images } from '../../data/mock';

const WhyYouSeeingSection = () => {
  return (
    <section id="whats-included" className="bg-bg-primary">
      {/* Top Section - Text Left, Image Right */}
      <div className="grid lg:grid-cols-2 min-h-[600px]">
        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 lg:px-12 xl:px-20 py-16 lg:py-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-text-primary leading-tight mb-8">
            {whyYouSeeingThis.title}
          </h2>
          <p className="text-lg text-text-secondary leading-relaxed mb-8 max-w-lg">
            {whyYouSeeingThis.content}
          </p>
          <p className="text-base text-text-light italic max-w-lg">
            {whyYouSeeingThis.note}
          </p>
        </div>

        {/* Image */}
        <div className="relative min-h-[400px] lg:min-h-full">
          <img
            src={images.hairstylist}
            alt="Hairstylist at work"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4">
        {[
          { icon: Globe, label: 'A fully branded website' },
          { icon: Calendar, label: 'Online booking' },
          { icon: Users, label: 'A client portal for managing appointments' },
          { icon: Smartphone, label: 'A mobile-friendly experience' }
        ].map((item, index) => (
          <div
            key={index}
            className={`p-8 lg:p-12 flex flex-col items-center text-center ${
              index % 2 === 0 ? 'bg-bg-secondary' : 'bg-bg-primary'
            }`}
          >
            <item.icon className="w-8 h-8 text-accent-orange mb-4" />
            <p className="text-sm lg:text-base text-text-primary font-medium">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyYouSeeingSection;
